import React, { useState, useCallback, useMemo, useContext } from 'react';
import useParsedTableData from '../../common/hooks/useParsedTableData';
import ClinicContext from '../../clinics/context/ClinicContext';
import { useDeleteClinicUser } from '../../clinics/redux/hooks';
import UpdateClinicUserDialog from '../../clinics/Management/ClinicDetails/UpdateClinicUserDialog';
import ManageUsersTable from '../../auth/Management/ManageUsersTable';

export default function UsersTable({ data, loading, handleOnAdd, minTableHeight, updateRole = true, showToolbar = false }) {
  const { id: clinicId, refetch } = useContext(ClinicContext);
  const [userData, setUserData] = useState({});
  const [updateUserDialogVisible, setUpdateUserDialogVisible] = useState(false);
  const { handleOnDeleteUser, deleteClinicUserPending } = useDeleteClinicUser(clinicId, refetch);

  const handleUpdateUserDialogClose = useCallback((isSuccess = false) => {
    setUpdateUserDialogVisible(false);
    if (isSuccess) {
      refetch();
    }
  }, [refetch]);

  const handleOnEdit = useCallback((userData) => {
    setUserData(userData);
    setUpdateUserDialogVisible(true);
  }, []);

  const actions = useMemo(() => {
    return { onEdit: handleOnEdit, onDelete: handleOnDeleteUser };
  }, [handleOnDeleteUser, handleOnEdit]);

  const { parsedData } = useParsedTableData(data, actions);

  return (
    <>
      <ManageUsersTable
        onAdd={handleOnAdd}
        loading={loading || deleteClinicUserPending}
        data={parsedData}
        showToolbar={showToolbar}
        minTableHeight={minTableHeight}
      />
      <UpdateClinicUserDialog open={updateUserDialogVisible}
        userUuid={userData?.uuid}
        updateRole={updateRole}
        clinicId={clinicId}
        onClose={handleUpdateUserDialogClose} 
      />
    </>
  );
}